export class AreaProjects {
    getProjects(workspaceId) {
        return this.dataCore.getForgeProjects(workspaceId);
    }
    updateProject(workspaceId, projectId, data) {
        return this.dataCore.updateForgeProject(workspaceId, projectId, data);
    }
    deleteProject(workspaceId, projectId) {
        return this.dataCore.deleteForgeProject(workspaceId, projectId);
    }
    createProject(workspaceId, data) {
        return this.dataCore.createForgeProject(workspaceId, data);
    }
    getProjectMemberships(workspaceId, projectId) {
        return this.dataCore.getForgeProjectMemberships(workspaceId, projectId);
    }
    getProjectContexts(workspaceId) {
        return this.dataCore.getForgeProjectContexts(workspaceId);
    }
    createProjectMember(workspaceId, projectId, data) {
        return this.dataCore.createForgeProjectMember(workspaceId, projectId, data);
    }
    updateProjectMember(workspaceId, projectId, memberId, data) {
        return this.dataCore.updateForgeProjectMember(workspaceId, projectId, memberId, data);
    }
    removeProjectMember(workspaceId, projectId, data) {
        return this.dataCore.removeForgeProjectMember(workspaceId, projectId, data);
    }
    getProjectFeature(workspaceId, projectId, featureId) {
        return this.dataCore.getForgeProjectFeature(workspaceId, projectId, featureId);
    }
    getProjectFeatures(workspaceId, projectId) {
        return this.dataCore.getForgeProjectFeatures(workspaceId, projectId);
    }
    projectAction(workspaceId, projectId, data) {
        return this.dataCore.projectAction(workspaceId, projectId, data);
    }
    createProjectFeature(workspaceId, projectId, data, tId) {
        return this.dataCore.createForgeProjectFeature(workspaceId, projectId, data, tId);
    }
    updateProjectFeature(workspaceId, projectId, data, tId) {
        return this.dataCore.updateForgeProjectFeature(workspaceId, projectId, data, tId);
    }
    deleteProjectFeature(workspaceId, projectId, data, tId) {
        return this.dataCore.deleteForgeProjectFeature(workspaceId, projectId, data, tId);
    }
    moveProjectFeature(workspaceId, projectId, data, tId) {
        return this.dataCore.moveForgeProjectFeature(workspaceId, projectId, data, tId);
    }
    createProjectArtifact(workspaceId, projectId, data, tId) {
        return this.dataCore.createForgeProjectArtifact(workspaceId, projectId, data, tId);
    }
    updateProjectArtifact(workspaceId, projectId, data, tId) {
        return this.dataCore.updateForgeProjectArtifact(workspaceId, projectId, data, tId);
    }
    deleteProjectArtifact(workspaceId, projectId, data, tId) {
        return this.dataCore.deleteForgeProjectArtifact(workspaceId, projectId, data, tId);
    }
    moveProjectArtifact(workspaceId, projectId, data, tId) {
        return this.dataCore.moveForgeProjectArtifact(workspaceId, projectId, data, tId);
    }
    createProjectSection(workspaceId, projectId, data, tId) {
        return this.dataCore.createForgeProjectSection(workspaceId, projectId, data, tId);
    }
    updateProjectSection(workspaceId, projectId, data, tId) {
        return this.dataCore.updateForgeProjectSection(workspaceId, projectId, data, tId);
    }
    deleteProjectSection(workspaceId, projectId, data, tId) {
        return this.dataCore.deleteForgeProjectSection(workspaceId, projectId, data, tId);
    }
    moveProjectSection(workspaceId, projectId, data, tId) {
        return this.dataCore.moveForgeProjectSection(workspaceId, projectId, data, tId);
    }
    async getProjectRoom(workspaceId, projectId) {
        return this.dataCore.getForgeProjectRoom(workspaceId, projectId);
    }
    async getProjectArtifactRoom(workspaceId, projectId, artifactId) {
        return this.dataCore.getForgeProjectArtifactRoom(workspaceId, projectId, artifactId);
    }
    async getProjectFeatureRoom(workspaceId, projectId, featureId) {
        return this.dataCore.getForgeProjectFeatureRoom(workspaceId, projectId, featureId);
    }
    async getProjectFeatureMessages(workspaceId, projectId, featureId) {
        return this.dataCore.getForgeProjectFeatureMessages(workspaceId, projectId, featureId);
    }
    async createProjectFeatureMessage(workspaceId, projectId, featureId, input) {
        return this.dataCore.createForgeProjectFeatureMessage(workspaceId, projectId, featureId, input);
    }
    async createProjectFeatureMessageReaction(workspaceId, projectId, featureId, input) {
        return this.dataCore.createForgeProjectFeatureMessageReaction(workspaceId, projectId, featureId, input);
    }
    async removeProjectFeatureMessageReaction(workspaceId, projectId, featureId, input) {
        return this.dataCore.removeForgeProjectFeatureMessageReaction(workspaceId, projectId, featureId, input);
    }
    async getProjectFeatureArtifacts(workspaceId, projectId, featureId) {
        return this.dataCore.getForgeProjectFeatureArtifacts(workspaceId, projectId, featureId);
    }
    async createProjectFeatureArtifact(workspaceId, projectId, featureId, input) {
        return this.dataCore.createForgeProjectFeatureArtifact(workspaceId, projectId, featureId, input);
    }
    async deleteProjectFeatureArtifact(workspaceId, projectId, featureId, input) {
        return this.dataCore.deleteForgeProjectFeatureArtifact(workspaceId, projectId, featureId, input);
    }
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
}
